// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./woff2-subset/Pretendard-Bold.subset.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./woff-subset/Pretendard-Bold.subset.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./woff2-subset/Pretendard-SemiBold.subset.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./woff-subset/Pretendard-SemiBold.subset.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./woff2-subset/Pretendard-Medium.subset.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./woff-subset/Pretendard-Medium.subset.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./woff2-subset/Pretendard-Regular.subset.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./woff-subset/Pretendard-Regular.subset.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Montserrat-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Copyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.
https://github.com/orioncactus/pretendard

This Font Software is licensed under the SIL Open Font License, Version 1.1.
This license is copied below, and is also available with a FAQ at:
http://scripts.sil.org/OFL
*/

@font-face {
  font-family: "Pretendard";
  font-weight: 700;
  font-display: fallback;
  src: local("Pretendard Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 600;
  font-display: fallback;
  src: local("Pretendard SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 500;
  font-display: fallback;
  src: local("Pretendard Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

@font-face {
  font-family: "Pretendard";
  font-weight: 400;
  font-display: fallback;
  src: local("Pretendard Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}

@font-face {
  font-family: "Montserrat";
  font-weight: 700;
  font-display: fallback;
  src: local("Montserrat BoldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/pretendard-subset.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB;;0DAE+D;AACjE;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB;;0DAEmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB;;0DAEiE;AACnE;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB;;0DAEkE;AACpE;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB;8DACqD;AACvD","sourcesContent":["/*\nCopyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.\nhttps://github.com/orioncactus/pretendard\n\nThis Font Software is licensed under the SIL Open Font License, Version 1.1.\nThis license is copied below, and is also available with a FAQ at:\nhttp://scripts.sil.org/OFL\n*/\n\n@font-face {\n  font-family: \"Pretendard\";\n  font-weight: 700;\n  font-display: fallback;\n  src: local(\"Pretendard Bold\"),\n    url(./woff2-subset/Pretendard-Bold.subset.woff2) format(\"woff2\"),\n    url(./woff-subset/Pretendard-Bold.subset.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Pretendard\";\n  font-weight: 600;\n  font-display: fallback;\n  src: local(\"Pretendard SemiBold\"),\n    url(./woff2-subset/Pretendard-SemiBold.subset.woff2) format(\"woff2\"),\n    url(./woff-subset/Pretendard-SemiBold.subset.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Pretendard\";\n  font-weight: 500;\n  font-display: fallback;\n  src: local(\"Pretendard Medium\"),\n    url(./woff2-subset/Pretendard-Medium.subset.woff2) format(\"woff2\"),\n    url(./woff-subset/Pretendard-Medium.subset.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Pretendard\";\n  font-weight: 400;\n  font-display: fallback;\n  src: local(\"Pretendard Regular\"),\n    url(./woff2-subset/Pretendard-Regular.subset.woff2) format(\"woff2\"),\n    url(./woff-subset/Pretendard-Regular.subset.woff) format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  font-weight: 700;\n  font-display: fallback;\n  src: local(\"Montserrat BoldItalic\"),\n    url(./Montserrat-BoldItalic.ttf) format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
